module.exports = __webpack_public_path__ + "300adf4134effa44f8984c7f4e8261e2.mp3";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/easy.mp3
// module id = 6
// module chunks = 0